import yaml from 'js-yaml';

const YAML_OPTIONS = {
  indent: 2,
  lineWidth: -1,
  noRefs: true,
  sortKeys: false
};

export function isJsonString(str: string): boolean {
  if (!str.trim().startsWith('{') && !str.trim().startsWith('[')) {
    return false;
  }
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}

export function formatAsYaml(data: unknown): string {
  if (data === null || data === undefined) {
    return '';
  }

  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      return yaml.dump(parsed, YAML_OPTIONS);
    } catch {
      return data;
    }
  }

  return yaml.dump(data, YAML_OPTIONS);
}
